import { render, staticRenderFns } from "./FormAssignment.vue?vue&type=template&id=3efda938&"
import script from "./FormAssignment.vue?vue&type=script&lang=js&"
export * from "./FormAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports